import {
  UPDATE_PLAYLIST_REQUEST,
  UPDATE_PLAYLIST_SUCCESS,
  UPDATE_PLAYLIST_ERROR,
  UPDATE_PLAYLIST_DONE,
} from "./actions";

const initialState = {
  requesting: false,
  successful: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PLAYLIST_REQUEST:
      return {
        requesting: true,
        successful: false,
      };

    case UPDATE_PLAYLIST_SUCCESS:
      return {
        requesting: false,
        successful: true,
      };

    case UPDATE_PLAYLIST_ERROR:
      return {
        requesting: false,
        successful: false,
      };

    case UPDATE_PLAYLIST_DONE:
      return initialState;

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/playlists/update/reducer.js